"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositAmountIntentRangeOptions = void 0;
var DepositAmountIntentRangeOptions;
(function (DepositAmountIntentRangeOptions) {
    DepositAmountIntentRangeOptions["BETWEEN_1000_AND_5000"] = "between_1000_5000";
    DepositAmountIntentRangeOptions["LESS_THAN_1000"] = "less_than_1000";
    DepositAmountIntentRangeOptions["MORE_THAN_5000"] = "more_than_5000";
})(DepositAmountIntentRangeOptions || (exports.DepositAmountIntentRangeOptions = DepositAmountIntentRangeOptions = {}));
